<template>
	<div class="user-center-container">
		<div class="user-center-content">
			<!-- <div class="form-header">
				<h3 class="form-title">我的收藏</h3>
			</div> -->

			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in tabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTab === index }]"
							@click="activeTab = index"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<!-- <div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
						<!== 用户收藏的政策资讯信息 ==>
						<collect-policy></collect-policy>
					</div> -->
					<div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
						<!-- 用户收藏的资质查-人员信息 -->
						<collect-person></collect-person>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 1 }]">
						<!-- 用户收藏的资质查-企业信息 -->
						<collect-unit></collect-unit>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 2 }]">
						<!-- 用户收藏的资质查-项目信息 -->
						<collect-project></collect-project>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CollectPolicy from './components/collectPolicy.vue'
	import CollectPerson from './components/collectPerson.vue'
	import CollectUnit from './components/collectUnit.vue'
	import CollectProject from './components/collectProject.vue'

	// 用户收藏
	export default {
		name: 'UserCollection',
		components: {
			CollectPolicy,
			CollectPerson,
			CollectUnit,
			CollectProject
		},
		props: {},
		data() {
			return {
				// 当前激活的选项
				activeTab: 0,
				tabs: [
					// { name: '行业快讯' },
					{ name: '资质查-人员' },
					{ name: '资质查-企业' },
					{ name: '资质查-项目' }
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/views/user/styles/user-center.scss';
</style>
